import { Box, BoxProps, Typography } from "@mui/material";
import { FC } from "react";

type NotesChipProps = BoxProps & {
  label: string;
  icon?: React.ReactNode;
};

const NoteChip: FC<NotesChipProps> = ({ label, icon, ...props }) => {
  return (
    <Box
      mt={0.5}
      display="flex"
      alignItems="center"
      alignSelf="flex-start"
      gap={0.5}
      borderRadius={1}
      paddingX={1}
      paddingY={0.5}
      sx={{ backgroundColor: "#E8DEF8" }}
      {...props}
    >
      {icon}
      <Typography color="custom.foreground.secondary" fontSize={13}>
        {label}
      </Typography>
    </Box>
  );
};

export default NoteChip;
